var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnquiry = function SvgEnquiry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 23.85H22.6V24V25V26.4204L19.5961 24.1096L19.3503 23.8885L19.3076 23.85H19.25H18.9H5.75C5.00784 23.85 4.4 23.2422 4.4 22.5V7.5C4.4 6.75784 5.00784 6.15 5.75 6.15H26.5C27.2422 6.15 27.85 6.75784 27.85 7.5V22.5C27.85 23.2422 27.2422 23.85 26.5 23.85H23.75H22.75ZM23.9 25.15H26.5C27.9578 25.15 29.15 23.9578 29.15 22.5V7.5C29.15 6.04216 27.9578 4.85 26.5 4.85H5.75C4.29216 4.85 3.1 6.04216 3.1 7.5V22.5C3.1 23.9578 4.29216 25.15 5.75 25.15H18.8488L23.6582 28.8687L23.9 29.0556V28.75V25.15Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1712 17.5795H17.0632V17.4318C17.0746 16.2273 17.4666 15.6761 18.3928 15.108C19.4382 14.483 20.0916 13.6307 20.0916 12.3295C20.0916 10.4091 18.5973 9.20455 16.4268 9.20455C14.4382 9.20455 12.8246 10.3068 12.7678 12.4659H14.7905C14.8416 11.3977 15.6143 10.8864 16.4155 10.8864C17.2848 10.8864 17.9837 11.4659 17.9837 12.358C17.9837 13.1534 17.4553 13.6989 16.7678 14.1307C15.7621 14.7557 15.1825 15.3864 15.1712 17.4318V17.5795ZM16.1655 21.125C16.8359 21.125 17.4098 20.5682 17.4155 19.875C17.4098 19.1932 16.8359 18.6364 16.1655 18.6364C15.4723 18.6364 14.9098 19.1932 14.9155 19.875C14.9098 20.5682 15.4723 21.125 16.1655 21.125Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnquiry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enquiry.390d84ca.svg";
export { ForwardRef as ReactComponent };